export var DIAGRAM_CONTAINER_ID = 'diagram__container';
export var DIAGRAM_COLUMN_CLASSNAME = 'diagram__column';
export var DiagramObjectType;
(function (DiagramObjectType) {
    DiagramObjectType["GROUP"] = "GROUP";
    DiagramObjectType["NODE"] = "NODE";
    DiagramObjectType["MINI_NODE"] = "MINI_NODE";
})(DiagramObjectType || (DiagramObjectType = {}));
//# sourceMappingURL=types.js.map